"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.795 6.604c.112-.45.762-.45.875 0l.038.153a6.39 6.39 0 0 0 4.12 4.477.421.421 0 0 1 0 .799 6.39 6.39 0 0 0-4.12 4.477l-.038.153c-.113.45-.763.45-.875 0l-.038-.154a6.39 6.39 0 0 0-4.12-4.476.421.421 0 0 1 0-.799 6.39 6.39 0 0 0 4.12-4.477zm5.617-3.399c.068-.273.464-.273.532 0l.023.094a3.89 3.89 0 0 0 2.508 2.725.256.256 0 0 1 0 .486 3.89 3.89 0 0 0-2.508 2.725l-.023.093c-.068.274-.464.274-.532 0l-.023-.093a3.89 3.89 0 0 0-2.508-2.725.256.256 0 0 1 0-.486 3.89 3.89 0 0 0 2.508-2.725z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AISparkleIcon20.js.map